import { searchUsersParams } from "../types/search.types";

const formatRange = (range: [number | string, number | string]) => `${range[0]}-${range[1]}`;

export const formatSearchUsersFormatter = (params: searchUsersParams) => {
  const queryParams: URLSearchParams = new URLSearchParams();

  const {
    limit = 12,
    offset = 0,
    name,
    role,
    gender,
    excludeFollowing,
    isFollowing,
    countryId,
    countryIds,
    hasFootballExperience,
    verificationStatus,
    nationalityId,
    trophiesRange,
    ageRange,
    heightRange,
    strongFoot,
    primaryPosition,
    otherPosition,
    hasAnAgent,
    weightRange,
    skillIds,
    playingLevelIds,
    hasCertificate,
    coachTypeId,
    preferredFormations,
    areasCovered,
    teamsCoachedRange,
    careerTransfersRange,
    scoutTypeId,
    scoutLocations,
    trendingStatus,
    coachType,
  } = params;

  // General params
  queryParams.append("limit", limit.toString());
  queryParams.append("offset", (Number(offset) * Number(limit)).toString());
  queryParams.append("role", role ?? coachType ?? "PLAYER");
  if (name) queryParams.append("name", name);
  if (gender) queryParams.append("gender", gender);
  if (excludeFollowing !== undefined) queryParams.append("excludeFollowing", excludeFollowing.toString());
  if (isFollowing !== undefined) queryParams.append("isFollowing", isFollowing.toString());
  if (countryId) queryParams.append("countryId", countryId);
  if (countryIds?.length) {
    Array.isArray(countryIds)
      ? queryParams.append("countryIds", countryIds?.join(","))
      : queryParams.append("countryIds", countryIds);
  }
  if (hasFootballExperience !== undefined)
    queryParams.append("hasFootballExperience", hasFootballExperience.toString());
  if (trendingStatus) queryParams.append("trendingStatus", "TRENDING_THIS_MONTH");
  if (verificationStatus) queryParams.append("verificationStatus", verificationStatus);
  if (nationalityId?.length) queryParams.append("nationalityId", nationalityId.join(","));
  if (trophiesRange?.length && trophiesRange[0] && trophiesRange[1])
    queryParams.append("trophiesRange", formatRange(trophiesRange));

  // Player params
  if (ageRange?.length && ageRange[0] && ageRange[1]) queryParams.append("ageRange", formatRange(ageRange));
  if (heightRange?.length && heightRange[0] && heightRange[1])
    queryParams.append("heightRange", formatRange(heightRange));
  if (strongFoot?.length) queryParams.append("strongFoot", strongFoot.join(","));
  if (primaryPosition) queryParams.append("primaryPosition", primaryPosition);
  if (otherPosition) queryParams.append("otherPosition", otherPosition);
  if (hasAnAgent !== undefined) queryParams.append("hasAnAgent", hasAnAgent.toString());
  if (weightRange?.length && weightRange[0] && weightRange[1])
    queryParams.append("weightRange", formatRange(weightRange));
  if (skillIds?.length) queryParams.append("skillIds", skillIds.join(","));
  if (playingLevelIds?.length) queryParams.append("playingLevelIds", playingLevelIds.join(","));

  // Professional params
  if (hasCertificate !== undefined) queryParams.append("hasCertificate", hasCertificate.toString());

  // Coach params
  if (coachTypeId?.length) queryParams.append("coachTypeId", coachTypeId.join(","));
  if (preferredFormations?.length) queryParams.append("preferredFormations", preferredFormations.join(","));
  if (areasCovered?.length) queryParams.append("areasCovered", areasCovered.join(","));
  if (teamsCoachedRange?.length && teamsCoachedRange[0] && teamsCoachedRange[1])
    queryParams.append("teamsCoachedRange", formatRange(teamsCoachedRange));

  // Agent params
  if (careerTransfersRange?.length && careerTransfersRange[0] && careerTransfersRange[1])
    queryParams.append("careerTransfersRange", formatRange(careerTransfersRange));

  // Scout params
  if (scoutTypeId?.length) queryParams.append("scoutTypeId", scoutTypeId.join(","));
  if (scoutLocations?.length) queryParams.append("scoutLocations", scoutLocations.join(","));

  if (coachType) queryParams.append("subRole", coachType);
  return queryParams;
};
